import { c as _c } from "react/compiler-runtime";
import type { TouchDesignDataPoint, TouchDesignSerie } from '../interfaces';
import { curveSmootherRequirementsSymbol, type CurveSmootherRequirements } from '@/lib/geometry/curve-smoother/curve-smoother.requirements';
import { SmoothStrategy } from '@/lib/geometry/curve-smoother/smooth-strategy.enum';
import { useNamedInjection } from '@/hooks/use-named-injection';
import type { CurveSmootherLeastSquaresRegressionOptions } from '@/lib/geometry/curve-smoother/curve-smoother-least-squares-regression';
import { useCallback } from 'react';
export const useSmoothedSerieLsr = options => {
  const $ = _c(5);
  const lsrSmoother = useNamedInjection(curveSmootherRequirementsSymbol, SmoothStrategy.LeastSquaresRegression);
  let t0;
  if ($[0] !== lsrSmoother || $[1] !== options) {
    t0 = inputSerie => {
      const inputData = inputSerie.data.map(_temp);
      const smoothedData = lsrSmoother.smoothCurve(inputData, options);
      const outputData = inputSerie.data.map((dataPoint_0, index) => ({
        ...dataPoint_0,
        payload: smoothedData[index]
      }));
      return {
        ...inputSerie,
        data: outputData
      };
    };
    $[0] = lsrSmoother;
    $[1] = options;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const smoothLsr = t0;
  let t1;
  if ($[3] !== smoothLsr) {
    t1 = {
      smoothLsr
    };
    $[3] = smoothLsr;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function _temp(dataPoint) {
  return dataPoint.payload;
}